import { GetHtmlSize } from './formaterBanner'

export function GetArrayTxtIndex(inicio, fim, file, inclusive = false, trim = false) {
  if (!file) return null;
  const saida = [];
  var aux = true;
  file = trim ? file.replaceAll(" ", "").replaceAll("\n", "") : file;
  var tempFile = file;
  if (!file) return null;
  while (aux) {
    const index = tempFile.indexOf(inicio);
    if (index === -1) { 
      aux = false;
      break;
    } else {
      tempFile = tempFile.slice(inclusive ? index : index + inicio.length, tempFile.length);
      file = tempFile;
      const indexCloseTag = tempFile.indexOf(fim);
      if (indexCloseTag === -1) {
        aux = false;
        break;
      } else {
        file = file.slice(0, inclusive ? indexCloseTag + fim.length  : indexCloseTag);
        saida.push(file);
        if (indexCloseTag + fim.length < tempFile.length) tempFile = tempFile.slice(indexCloseTag + fim.length, tempFile.length);
        else aux = false;
      }
    }
  }
  if (saida.length === 0) return [null];
  return saida;
}

export function GetLastAtributte(inicio, file) {
  if (!file) return null;
  file = file.replaceAll(" ", "").replaceAll("\n", "");
  const index = file.indexOf(inicio);
  if (index === -1) { 
    return null;
  } else {
    file = file.slice(index + inicio.length, file.length);
    const indexCloseTag = file.indexOf(";");
    if (indexCloseTag === -1) {
      return file;
    } else {
      return null;
    }
  }
}

export function GetBodyHtml(html) {
  if (!html) return null;
  return GetArrayTxtIndex("<body>", "</body>", html, true, false);
}

export function GetElementsHtml(html) {
  if (!html) return null;
  return GetArrayTxtIndex("id=\"", "\"", GetBodyHtml(html)[0], false, true);
}

export function GetSizeHtml(html) {
  if (!html) return null;
  var size = GetArrayTxtIndex("<metaname=\"ad.size\"content=\"", "\"", html, false, true)[0];
  return size.replace("width=", "").replace("height=","").split(",");
}

function GetElementsCSS(elements, html) {
  const elementsCSS = [];
  const styles = GetArrayTxtIndex("<style>", "</style>", html, false, true);

  elements.forEach(element => {
    styles.forEach(style => {
      var copyStyle = style;
      const indexOpenTag = copyStyle.indexOf("." + element + "{");
      if (indexOpenTag > 0) {
        copyStyle = copyStyle.slice(indexOpenTag + 2 + element.length, copyStyle.length);
        const indexCloseTag = copyStyle.indexOf("}");
      if (indexCloseTag > 0) {
        copyStyle = copyStyle.slice(0, indexCloseTag);
        const elCSS = {};
        elCSS.element = element;
        elCSS.css = copyStyle;
        elementsCSS.push(elCSS)
        }
      }
    });
  });

  return elementsCSS;
}

function GetElementsProperties(elementsCSS, body) {
  const elements = [];
  elementsCSS.forEach(item => {
    const el = {};
    el.id = item.element;
    el.step = getElementStep(item.element);
    el.enabled = true;
    el.project = false;
    el.type = getElementType(item.element);
    el.properties = getProperties(item.css, el.type);
    if (el.type === "txt") {
      el.properties.text = getElementText(el.id, body);
    } else el.properties.text = null;
    elements.push(el);
  });
  return elements;
}

function getElementText(id, body) {
  var inner = GetArrayTxtIndex(`id="${id}"`, "</div>", body,  true, false);
  inner = GetArrayTxtIndex(">", "</div>", inner[0],  false, false);

  return inner[0];
}

function getElementType(element) {
  var type;
  type = GetArrayTxtIndex("_", "_", element,  false, false)[0];
  if (!type) type = element;
  if (type.includes("bg")) return "bg";
  if (type.includes("txt")) return "txt";  
  return "img";
}

function getProperties(style, type) {
  const properties = {};
  const background = GetArrayTxtIndex("background:url(", ")no-repeat", style, false, true)[0];
  const backgroundColor = GetArrayTxtIndex("background-color:", ";", style, false, true)[0];
  const position = GetArrayTxtIndex("position:", ";", style, false, true)[0];
  const left = GetArrayTxtIndex("left:", ";", style, false, true)[0] === null ? null : GetArrayTxtIndex("left:", ";", style, false, true)[0].replace("px", "");
  const top = GetArrayTxtIndex("top:", ";", style, false, true)[0] === null ? null : GetArrayTxtIndex("top:", ";", style, false, true)[0].replace("px", "");
  const width = GetArrayTxtIndex("width:", ";", style, false, true)[0] === null ? null : GetArrayTxtIndex("width:", ";", style, false, true)[0].replace("px", "");
  const height = GetArrayTxtIndex("height:", ";", style, false, true)[0] === null ? null : GetArrayTxtIndex("height:", ";", style, false, true)[0].replace("px", "");
  const opacity = GetArrayTxtIndex("opacity:", ";", style, false, true)[0] === null ? 0 : GetArrayTxtIndex("opacity:", ";", style, false, true)[0];
  const color = GetArrayTxtIndex("color:", ";", style, false, true)[0];
  const fontSize = GetArrayTxtIndex("font-size:", ";", style, false, true)[0] ? GetArrayTxtIndex("font-size:", ";", style, false, true)[0].replace("px", "") : null;
  const textAlign = GetArrayTxtIndex("text-align:", ";", style, false, true)[0];
  const transform = GetArrayTxtIndex("transform:", ";", style, false, true)[0];
  const transformOrigin = GetArrayTxtIndex("transform-origin:", ";", style, false, true)[0];
  const fontFamily = GetArrayTxtIndex("font-family:", ";", style, false, true)[0];
  const zIndex = GetArrayTxtIndex("z-index:", ";", style, false, true)[0];

  properties.background = background ? background : GetArrayTxtIndex("background:url('", "')no-repeat", style, false, true)[0];
  properties.backgroundColor = backgroundColor ? backgroundColor : GetArrayTxtIndex("background-color:", "}", style, false, true)[0];
  properties.originalBackground = properties.background;
  properties.position = position ? position : GetArrayTxtIndex("position:", "}", style, false, true)[0];
  properties.left = left ? left : GetArrayTxtIndex("left:", "}", style, false, true)[0] === null ? null : GetArrayTxtIndex("left:", "}", style, false, true)[0].replace("px", "");
  properties.top = top ? top : GetArrayTxtIndex("top:", "}", style, false, true)[0] === null ? null : GetArrayTxtIndex("top:", "}", style, false, true)[0].replace("px", "");
  properties.width = width ? width : GetArrayTxtIndex("width:", "}", style, false, true)[0] === null ? null : GetArrayTxtIndex("width:", "}", style, false, true)[0].replace("px", "");
  properties.height = height ? height : GetArrayTxtIndex("height:", "}", style, false, true)[0] === null ? null : GetArrayTxtIndex("height:", "}", style, false, true)[0].replace("px", "");
  properties.opacity = opacity ? opacity : GetLastAtributte("opacity:", style) === null ? null : GetLastAtributte("opacity:", style);
  properties.color = properties.backgroundColor ? null : color ? color : GetArrayTxtIndex("color:", "}", style, false, true)[0];
  properties.fontSize = fontSize ? fontSize : GetArrayTxtIndex("font-size:", "}", style, false, true)[0] ? GetArrayTxtIndex("font-size:", "}", style, false, true)[0].replace("px", "") : null;
  properties.textAlign = textAlign ? textAlign : GetArrayTxtIndex("text-align:", "}", style, false, true)[0];
  properties.transform = transform ? transform : GetArrayTxtIndex("transform:", "}", style, false, true)[0];
  properties.transformOrigin = transformOrigin ? transformOrigin : GetArrayTxtIndex("transform-origin:", "}", style, false, true)[0];
  properties.fontFamily = fontFamily ? fontFamily : GetArrayTxtIndex("font-family:", "}", style, false, true)[0];
  properties.zIndex = zIndex ? zIndex : GetArrayTxtIndex("z-index:", "}", style, false, true)[0] === null ? null : GetArrayTxtIndex("z-index:", "}", style, false, true)[0];
  properties.scale = 100;
  properties.zIndex = type === "bg" ? 0 : properties.zIndex;
  properties.background = properties.background.replaceAll("'", "");
  
  if (properties.transform && properties.transform.includes("rotate")) properties.rotate = properties.transform.replaceAll("rotate(", "").replaceAll(")","");
  else properties.rotate = "0";

  return properties;
}

function getElementStep(element) {
  try {
    element = element.split("_")[0];
    var numsStr = element.replace(/[^0-9]/g,'');
    return parseInt(numsStr);
  } catch (error) {
    return 0;
  }
}


function GetAnimation(html) {
  const styles = GetArrayTxtIndex("<style>", "</style>", html, true, false);
  var result = null;
  styles.forEach(style => {
    if (style.includes(".all_in") || style.includes(".all_out") || style.includes("keyframes")) {
      result = style;
    }
  });
  return result;
}

function GetTimeline(body) {
  var timeline = GetArrayTxtIndex("timeline.animationElements(", "]);", body, false, true);
  if (timeline[0] === null) return "";
  const tline = [];
  for (var i = 0; i < timeline.length; i++) {
    timeline[i] = timeline[i].replaceAll("[", "").replaceAll("]", "").replaceAll("\\", "").replaceAll("\"", "");
    tline.push(timeline[i].split(","));
  }
  return tline;
}

function GetElementAnimation(element, timeline) {
  var animation = "";
  timeline.forEach(item => {
    if (item[1] === "." + element) {
      if (animation === "") animation +=  item[0];
      else animation += ";" + item[0];
    }
  });
  return animation;
}

export function HtmltoObject(html) {
  if (!html) return null;
  const banner = {};
  const size = GetSizeHtml(html);
  const elementsCSS = GetElementsCSS(GetElementsHtml(html), html);
  banner.versao = "1.0";
  banner.body = GetBodyHtml(html)[0];
  banner.width = parseInt(size[0]);
  banner.height = parseInt(size[1]);
  const elements = GetElementsProperties(elementsCSS, banner.body);
  banner.elements = elements;
  banner.animation = GetAnimation(html);
  banner.optimize = 100;
  banner.size = GetHtmlSize(html);
  const timeline = GetTimeline(banner.body);
  if (timeline !== "") {
    banner.estatico = false;
    banner.elements.forEach(element => {
      element.animation = GetElementAnimation(element.id, timeline);
      element.out = element.animation.toLowerCase().includes("out");
    });
  } else banner.estatico = true;
  return banner;
}
